import { render, staticRenderFns } from "./panels.vue?vue&type=template&id=4c146a99&scoped=true"
import script from "./panels.vue?vue&type=script&lang=js"
export * from "./panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c146a99",
  null
  
)

export default component.exports